const SUPPORTED_LOCALES = [
  'de',
  'en',
  'en-au',
  'en-ca',
  'en-us',
  'fi',
  'fr',
  'nl',
];

export const INTL_LOCALE_STORAGE_KEY = 'intl-locale';

export async function loadTranslations(intl, locales) {
  for (const locale of locales) {
    if (SUPPORTED_LOCALES.includes(locale)) {
      let translations = await import(`/translations/${locale}.json`);
      intl.addTranslations(locale, translations);
    }
  }
}

export function pickLocale(locales) {
  for (let i = 0, len = locales.length; i < len; i++) {
    let locale = locales[i];
    if (SUPPORTED_LOCALES.includes(locale)) {
      return locale;
    }
  }
  return 'en';
}

export function prepareIntlLocale({ lang, countryCode } = {}) {
  let locales = [];
  if (lang && countryCode) {
    const locale = `${lang}-${countryCode}`.toLowerCase();
    locales.push(locale);

    // Special handling for en-ca fallback chain
    if (locale === 'en-ca') {
      locales.push('en-us');
    }
  }
  if (lang) {
    locales.push(lang);
  }
  if (!locales.includes('en')) {
    locales.push('en');
  }

  return locales;
}
